import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Children, useState } from 'react';
import classnames from 'classnames';
import styles from './Tabs.scss';
export var Tab = function Tab(p) {
  return p.children;
};

var Tabs = function Tabs(_ref) {
  var currentTabProp = _ref.currentTab,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      onChange = _ref.onChange,
      children = _ref.children;
  var isControlled = currentTabProp !== undefined;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentTabState = _useState2[0],
      setCurrentTab = _useState2[1];

  var currentTab = currentTabProp !== undefined ? currentTabProp : currentTabState;
  var childrenArray = Children.toArray(children);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(_defineProperty({}, styles.isFullWidth, isFullWidth))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.head
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.titles
  }, childrenArray.map(function (tab, i) {
    return /*#__PURE__*/React.createElement("button", {
      key: String(i),
      onClick: function onClick() {
        if (onChange) onChange(i);
        if (!isControlled) setCurrentTab(i);
      },
      type: "button",
      className: classnames(styles.title, _defineProperty({}, styles.isActive, i === currentTab))
    }, typeof tab.props.title === 'function' ? tab.props.title({
      isActive: i === currentTab
    }) : tab.props.title);
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, childrenArray[currentTab]));
};

export default Tabs;